import { Impulse, type Scope } from "~/tools/impulse";
import type { Point } from "~/tools/point";

export interface TimelineHoveredLine {
	position: Point;
	popoverId: string;
}

export class TimelineLineState {
	private readonly linePopup = Impulse<TimelineHoveredLine>();
	public readonly hoveredLine = Impulse<TimelineHoveredLine>();

	public getLinePopup(scope: Scope): undefined | TimelineHoveredLine {
		return this.hoveredLine.getValue(scope) ?? this.linePopup.getValue(scope);
	}

	public setLinePopup(event: undefined | TimelineHoveredLine): void {
		this.linePopup.setValue(event);
	}
}
